<template>
  <div class="policy-page">
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy">
          <p class="eyebrow">BAILYHANGA / Privacy Policy</p>
          <h1>{{ texts.title }}</h1>
          <p class="lead">{{ texts.lead }}</p>
        </div>
        <div class="document-stamp" aria-label="Document information">
          <span>PRIVACY / 01</span>
          <strong>DATA &amp; TRUST</strong>
          <small>PUBLIC DOCUMENT / 2026.08</small>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container card">
        <section class="policy-section">
          <h2>{{ texts.scopeTitle }}</h2>
          <p>{{ texts.scopeText1 }}</p>
          <p>{{ texts.scopeText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.collectTitle }}</h2>
          <ul>
            <li v-for="item in texts.collectItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.useTitle }}</h2>
          <ul>
            <li v-for="item in texts.useItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.shareTitle }}</h2>
          <ul>
            <li v-for="item in texts.shareItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.securityTitle }}</h2>
          <ul>
            <li v-for="item in texts.securityItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.retentionTitle }}</h2>
          <p>{{ texts.retentionText1 }}</p>
          <p>{{ texts.retentionText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.rightsTitle }}</h2>
          <ul>
            <li v-for="item in texts.rightsItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.transferTitle }}</h2>
          <p>{{ texts.transferText1 }}</p>
          <p>{{ texts.transferText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.childTitle }}</h2>
          <p>{{ texts.childText1 }}</p>
          <p>{{ texts.childText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.updateTitle }}</h2>
          <p>{{ texts.updateText }}</p>
        </section>

        <div class="notice">
          <span class="notice-label">Privacy Contact</span>
          <strong>{{ texts.noticeLabel }}</strong>
          {{ texts.noticeText }}
        </div>

        <div class="actions">
          <router-link :to="{ name: 'spApiComplianceDetail' }" class="action-link">
            {{ texts.complianceLink }} <span>&rarr;</span>
          </router-link>
          <router-link :to="{ name: 'BrandAnalyticsDetail' }" class="action-link">
            {{ texts.brandLink }} <span>&rarr;</span>
          </router-link>
          <a class="action-link primary" :href="contactHref">{{ texts.contactLink }} <span>&rarr;</span></a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";

export default {
  name: "PrivacyPolicy",
  data() {
    return {
      copy: {
        zh: {
          title: "隐私政策",
          lead:
            "本政策说明GO GLOBAL CREDIT LIMTED如何收集、使用、存储、保护和共享与本网站及跨境电商 SaaS 服务相关的信息，特别是与 Amazon SP-API 数据处理有关的隐私与安全要求。",
          scopeTitle: "1. 适用范围",
          scopeText1:
            "本隐私政策适用于本网站以及我们向亚马逊卖家、品牌所有者及其授权团队提供的软件和运营支持服务。",
          scopeText2:
            "我们仅在合法、正当、必要和最小化的范围内处理信息，并遵循适用的数据保护法律法规以及 Amazon SP-API 的合规要求。",
          collectTitle: "2. 我们可能收集的信息",
          collectItems: [
            "账户与注册信息：如姓名、邮箱、手机号、公司名称、登录信息及身份验证信息。",
            "业务数据：如订单、库存、物流、财务、广告和运营分析数据，以及客户在系统内主动录入的信息。",
            "设备与访问日志：如 IP 地址、浏览器类型、设备信息、访问时间、操作日志和异常排查记录。",
            "客户支持信息：如您在工单、邮件、截图或客服沟通中主动提供的信息。",
            "Amazon SP-API 相关数据：在客户明确授权后，我们可能访问与履约、订单、品牌分析或经营管理相关的数据；如涉及买家个人信息，仅限于服务所必需的场景使用。",
          ],
          useTitle: "3. 信息使用目的",
          useItems: [
            "提供账号注册、登录、身份校验和基础产品功能。",
            "支持订单履约、库存协同、财务分析、广告运营和品牌分析等业务场景。",
            "提供客户支持、故障排查、安全监控和服务优化。",
            "满足法律法规、监管、审计和 Amazon 平台合规要求。",
            "我们不会将通过 Amazon SP-API 获取的数据用于与服务无关的用途。",
          ],
          shareTitle: "4. 信息共享与披露",
          shareItems: [
            "未经您的明确授权，我们不会出售、出租、转让或公开披露您的个人信息或 Amazon SP-API 数据。",
            "仅在履行服务所必需、且具备合法依据的情况下，才会与受约束的合作方共享必要信息，例如物流、仓储、云服务或安全服务提供商。",
            "如法律法规、司法或监管要求必须披露相关信息，我们将在符合法律要求的前提下进行必要披露。",
            "我们不会将多个卖家或多个品牌的 Amazon 数据聚合后向公众展示、出售或开放下载。",
          ],
          securityTitle: "5. 数据安全措施",
          securityItems: [
            "对敏感数据传输和存储采取加密保护措施，并实施最小权限访问控制。",
            "仅授权员工可访问履行岗位职责所需的数据，并保留访问日志用于审计和风险追踪。",
            "定期进行安全检查、权限复核、异常监控和漏洞修复。",
            "如发生安全事件，我们将按适用法律和平台要求启动应急响应并采取必要通知措施。",
          ],
          retentionTitle: "6. 数据保留与删除",
          retentionText1:
            "我们仅在实现本政策所述目的所必需的期限内保留相关数据，超过必要期限后将删除或匿名化处理。",
          retentionText2:
            "如您提出访问、更正、删除或撤回授权请求，我们将在核验身份后按照适用法律及 Amazon 规则处理。",
          rightsTitle: "7. 您的权利",
          rightsItems: [
            "您可以依法申请访问、更正、补充或删除您的个人信息。",
            "您可以申请限制处理、撤回授权，或在适用情况下请求数据副本。",
            "如对数据处理有疑问或异议，您可以通过本页提供的联系方式与我们沟通。",
          ],
          transferTitle: "8. 跨境传输",
          transferText1:
            "基于跨境电商业务特点，部分数据可能在不同国家或地区的服务器中存储、传输或处理。",
          transferText2:
            "在涉及跨境传输时，我们将采取合同约束、加密保护及其他必要措施，确保数据处理符合适用法律及平台要求。",
          childTitle: "9. 未成年人信息",
          childText1:
            "我们的产品和服务主要面向成年人及企业用户，不以未成年人为主要服务对象。",
          childText2:
            "如发现未经监护人同意收集了未成年人信息，我们将在核实后尽快删除相关数据。",
          updateTitle: "10. 政策更新",
          updateText:
            "我们可能根据法律法规、业务变化或合规要求更新本政策。更新后的版本将在网站发布后生效，继续使用服务即表示您理解并接受更新内容。",
          noticeLabel: "联系方式：",
          noticeText:
            "如您对本隐私政策或数据处理事项有任何疑问，请联系 keith.lu@hysenglobal.com，我们将在合理期限内回复。",
          complianceLink: "查看 SP-API 合规说明",
          brandLink: "查看品牌分析功能",
          contactLink: "联系隐私团队",
          contactSubject: "隐私政策咨询",
        },
        en: {
          title: "Privacy Policy",
          lead:
            "This policy explains how GO GLOBAL CREDIT LIMTED collects, uses, stores, protects, and shares information related to this website and our cross-border e-commerce SaaS services, especially for Amazon SP-API privacy and security compliance.",
          scopeTitle: "1. Scope",
          scopeText1:
            "This Privacy Policy applies to this website and to the software and operational support services we provide to Amazon sellers, brand owners, and their authorized teams.",
          scopeText2:
            "We process information only on a lawful, legitimate, necessary, and data-minimized basis, in compliance with applicable data protection laws and Amazon SP-API requirements.",
          collectTitle: "2. Information We May Collect",
          collectItems: [
            "Account and registration information, such as name, email, phone number, company name, login details, and authentication information.",
            "Business data, such as orders, inventory, logistics, finance, advertising, operations analytics, and information entered by customers into the system.",
            "Device and access logs, such as IP address, browser type, device information, access time, operation logs, and troubleshooting records.",
            "Customer support information, including data you provide through tickets, email, screenshots, or support communications.",
            "Amazon SP-API-related data. After explicit authorization, we may access data related to fulfillment, orders, brand analytics, or business management. If buyer personal information is involved, it is used only where necessary for service delivery.",
          ],
          useTitle: "3. Purposes of Use",
          useItems: [
            "To provide account registration, sign-in, identity verification, and core product functionality.",
            "To support business scenarios such as order fulfillment, inventory collaboration, financial analysis, advertising operations, and brand analytics.",
            "To provide customer support, troubleshooting, security monitoring, and service optimization.",
            "To satisfy legal, regulatory, audit, and Amazon platform compliance requirements.",
            "We do not use Amazon SP-API data for purposes unrelated to the services we provide.",
          ],
          shareTitle: "4. Sharing and Disclosure",
          shareItems: [
            "Without your explicit authorization, we do not sell, rent, transfer, or publicly disclose your personal information or Amazon SP-API data.",
            "We share necessary information only where required to provide the service and where there is a lawful basis, for example with constrained logistics, warehousing, cloud, or security service providers.",
            "If disclosure is required by law, regulation, judicial process, or regulatory request, we may disclose necessary information in accordance with applicable requirements.",
            "We do not aggregate Amazon data across multiple sellers or brands for public display, sale, or open download.",
          ],
          securityTitle: "5. Data Security Measures",
          securityItems: [
            "We apply encryption safeguards to sensitive data in transit and at rest, together with least-privilege access controls.",
            "Only authorized employees may access the data required for their job responsibilities, and access logs are retained for auditing and risk tracking.",
            "We conduct regular security reviews, permission checks, anomaly monitoring, and vulnerability remediation.",
            "If a security incident occurs, we will activate our response process and provide necessary notifications in accordance with applicable law and platform requirements.",
          ],
          retentionTitle: "6. Data Retention and Deletion",
          retentionText1:
            "We retain relevant data only for as long as necessary to fulfill the purposes described in this policy, after which the data will be deleted or anonymized.",
          retentionText2:
            "If you request access, correction, deletion, or withdrawal of authorization, we will verify your identity and process the request in accordance with applicable law and Amazon requirements.",
          rightsTitle: "7. Your Rights",
          rightsItems: [
            "You may request access to, correction of, supplementation of, or deletion of your personal information where permitted by law.",
            "You may request restriction of processing, withdrawal of authorization, or a copy of your data where applicable.",
            "If you have questions or objections regarding data processing, you may contact us using the details provided on this page.",
          ],
          transferTitle: "8. Cross-Border Transfers",
          transferText1:
            "Due to the nature of cross-border e-commerce, certain data may be stored, transmitted, or processed on servers located in different countries or regions.",
          transferText2:
            "Where cross-border transfers are involved, we use contractual protections, encryption, and other necessary safeguards to ensure compliance with applicable laws and platform requirements.",
          childTitle: "9. Children's Information",
          childText1:
            "Our products and services are primarily intended for adults and business users and are not designed for children as a primary audience.",
          childText2:
            "If we discover that information from a child has been collected without guardian consent, we will delete the relevant data as soon as reasonably possible after verification.",
          updateTitle: "10. Policy Updates",
          updateText:
            "We may update this policy based on legal, regulatory, business, or compliance changes. The updated version becomes effective when published on the website, and your continued use of the service means you understand and accept the update.",
          noticeLabel: "Contact:",
          noticeText:
            "If you have any questions about this Privacy Policy or our data handling practices, please contact keith.lu@hysenglobal.com and we will respond within a reasonable period.",
          complianceLink: "View SP-API Compliance Statement",
          brandLink: "View Brand Analytics Features",
          contactLink: "Contact Privacy Team",
          contactSubject: "Privacy policy inquiry",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale] || this.copy.zh;
    },
    contactHref() {
      return `mailto:keith.lu@hysenglobal.com?subject=${encodeURIComponent(
        this.texts.contactSubject
      )}`;
    },
  },
};
</script>

<style>
.policy-page {
  --ink: #122620;
  --paper: #f5f2e9;
  --accent: #b86d35;
  --line: rgba(18, 38, 32, 0.16);
  background: var(--paper);
  color: var(--ink);
  padding-bottom: 0;
}
.hero {
  background: #d9d3c5;
  color: var(--ink);
  padding: 5rem 0;
}
.container {
  box-sizing: border-box;
  max-width: 80rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.hero-grid {
  align-items: end;
  display: grid;
  gap: 3rem;
}
.hero-copy { text-align: left; }
.eyebrow {
  color: var(--accent);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 1.4rem;
  opacity: 1;
}
h1 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 3rem;
  font-weight: 400;
  line-height: 1.08;
}
.lead {
  color: rgba(18, 38, 32, 0.66);
  font-size: 0.96rem;
  line-height: 1.85;
  margin: 1.5rem 0 0;
  max-width: 48rem;
}
.document-stamp {
  border-left: 3px solid var(--accent);
  padding: 0.75rem 0 0.75rem 1.25rem;
  text-align: left;
}
.document-stamp span,
.document-stamp small {
  color: rgba(18, 38, 32, 0.48);
  display: block;
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 0.64rem;
  letter-spacing: 0.1em;
}
.document-stamp strong {
  color: var(--ink);
  display: block;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.25;
  margin: 0.7rem 0;
}
.content { padding: 0; }
.card {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  margin-top: 0;
  padding: 0;
}
.policy-section {
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 1.25rem;
  padding: 3.5rem 0;
}
.policy-section + .policy-section { margin-top: 0; }
.policy-section h2 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}
.policy-section p,
.policy-section li {
  color: rgba(18, 38, 32, 0.67);
  font-size: 0.9rem;
  line-height: 1.85;
  margin-bottom: 0;
}
.policy-section p { margin-top: 0; }
.policy-section p + p { margin-top: 1rem; }
.policy-section ul {
  border-top: 1px solid var(--line);
  list-style: none;
  margin: 0;
  padding: 0;
}
.policy-section li {
  border-bottom: 1px solid var(--line);
  padding: 0.9rem 0 0.9rem 1.25rem;
  position: relative;
}
.policy-section li::before {
  background: var(--accent);
  content: "";
  height: 5px;
  left: 0;
  position: absolute;
  top: 1.7rem;
  width: 5px;
}
.policy-page .policy-section:nth-of-type(4) {
  background: var(--ink);
  box-sizing: border-box;
  margin-left: 0;
  margin-right: 0;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.policy-page .policy-section:nth-of-type(4) h2 { color: #f7f3e8; }
.policy-page .policy-section:nth-of-type(4) ul { border-color: rgba(247, 243, 232, 0.18); }
.policy-page .policy-section:nth-of-type(4) li {
  border-color: rgba(247, 243, 232, 0.18);
  color: rgba(247, 243, 232, 0.68);
}
.notice {
  background: #d9d3c5;
  border: 0;
  border-radius: 0;
  color: rgba(18, 38, 32, 0.7);
  line-height: 1.8;
  margin: 0;
  padding: 3.5rem 1.25rem;
}
.notice-label {
  color: var(--accent);
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  margin-bottom: 1rem;
  text-transform: uppercase;
}
.notice strong {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.6rem;
  font-weight: 400;
}
.actions {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 1.5rem 0 5rem;
}
.action-link {
  align-items: center;
  border: 0;
  border-bottom: 1px solid var(--line);
  border-radius: 0;
  color: var(--ink);
  display: flex;
  font-size: 0.82rem;
  justify-content: space-between;
  padding: 1rem 0;
}
.action-link.primary {
  background: var(--ink);
  color: #f7f3e8;
  margin-top: 1rem;
  padding: 1rem;
}
@media (min-width: 1024px) {
  .hero { padding: 7rem 0 6rem; }
  .hero-grid { grid-template-columns: 1.45fr 0.55fr; gap: 6rem; }
  h1 { font-size: 4.25rem; }
  .policy-section {
    gap: 4rem;
    grid-template-columns: 0.7fr 1.3fr;
    padding: 5rem 0;
  }
  .policy-section h2 { font-size: 2.6rem; }
  .policy-section > p,
  .policy-section > ul { grid-column: 2; }
  .policy-section > h2 + p,
  .policy-section > h2 + ul { grid-row: 1; }
  .policy-section > p + p { grid-column: 2; margin-top: -2rem; }
  .policy-page .policy-section:nth-of-type(4) {
    margin-left: calc((80rem - 100vw) / 2);
    margin-right: calc((80rem - 100vw) / 2);
    padding-left: max(1.25rem, calc((100vw - 80rem) / 2));
    padding-right: max(1.25rem, calc((100vw - 80rem) / 2));
  }
  .notice { margin-left: calc((80rem - 100vw) / 2); margin-right: calc((80rem - 100vw) / 2); padding: 5rem max(1.25rem, calc((100vw - 80rem) / 2)); }
  .actions { grid-template-columns: repeat(3, 1fr); padding-bottom: 6rem; }
  .action-link { border-right: 1px solid var(--line); padding: 1.2rem; }
  .action-link.primary { margin-top: 0; }
}
@media (max-width: 560px) {
  .hero { padding: 4rem 0; }
  h1 { font-size: 2.5rem; }
  .policy-section h2 { font-size: 1.8rem; }
  .document-stamp strong { font-size: 1.3rem; overflow-wrap: anywhere; }
}

</style>
